import { useEffect, useImperativeHandle, useState } from 'react';
import parse from 'html-react-parser';
import { getPilotAssignmentUrl, isPilotAssignmentCompleted, isPilotAssignmentConfirmed, isPilotAssignmentCorrectionNeeded, setPilotAssignmentSuggestions } from '../pilot-assignment/helpers/PilotAssignmentHelpers';
import { deepCopyObject, isNullOrEmpty, isObjectNull } from '../../../components/helpers/ObjectHelpers';
import PilotAssignmentIdbRepository from '../../../repositories/idb/PilotAssignmentIdbRepository';
import { useNavigate, useParams } from 'react-router';
import { BottomMenu } from '../../../components/layout/menus/bottom/BottomMenu';
import { usePilotageStoreContext } from '../../../components/hooks/usePilotageStoreContext';
import { useStoreSelector } from '../../../components/hooks/useStoreSelector';

export const PilotagDetailsMenuStates = {
    PilotAssignment: "PILOT_ASSIGNMENT",
    Information: "INFORMATION",
    Ship: "SHIP",
    Observations: "OBSERVATIONS",
    Map: "MAP"
}

export const PilotageDetailsBottomMenu = ({
    ref,
    pilotAssignment,
    view}) => {

    const navigate = useNavigate();
    const { id } = useParams();

    const [isBusy, setIsBusy] = useState(false);
    const [items, setItems] = useState([]);

    const pilotageStore = usePilotageStoreContext();
    const hasObservation = useStoreSelector(pilotageStore, (state) => state.hasObservation);
    const setHasChanges = useStoreSelector(pilotageStore, (state) => state.setHasChanges);

    const initialize = (hasObservation) => {
        if (isObjectNull(pilotAssignment)) return;
        setIsBusy(true);
        const menuItems = getBottomMenuItems(hasObservation);
        setItems(menuItems);

        setTimeout(() => {
            setIsBusy(false);
        }, 125);
    }

    useEffect(() => {
        initialize(pilotAssignment.pilotage.hasObservation);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pilotAssignment]);

    useImperativeHandle(ref, () => ({
        async onPilotAssignmentChange() {
            const updatedItems = deepCopyObject(items);
            const item = updatedItems.find(i => i.event === PilotagDetailsMenuStates.PilotAssignment);
            
            if (isObjectNull(item)) return;

            const assignment = await PilotAssignmentIdbRepository.getAsync(pilotAssignment.pilotagePilotId);
            setHasChanges(isPilotAssignmentDirty(assignment));
        },
    }));

    return (
        !isBusy &&
        <BottomMenu
            items={items}
            selectedEvent={view}
            onCallback={onSelect}
        />
    )

    function getBottomMenuItems() {
        if (isNullOrEmpty(pilotAssignment.pilotagePilotId)) return [];

        const items = [
            {
                title: "Info",
                icon: "information",
                event: PilotagDetailsMenuStates.Information
            },
            {
                title: parse("Fart&oslash;y"),
                icon: "ship",
                event: PilotagDetailsMenuStates.Ship,
                hasObservations: hasObservation
            },
        ];

        if (
            (
                isPilotAssignmentConfirmed(pilotAssignment) ||
                isPilotAssignmentCorrectionNeeded(pilotAssignment) ||
                isPilotAssignmentCompleted(pilotAssignment)
            )
        ) {

            items.push({
                title: "Sk.bevis",
                icon: "document",
                event: PilotagDetailsMenuStates.PilotAssignment,
                hasChanges: isPilotAssignmentDirty(pilotAssignment)
            });
        }

        if (navigator.onLine) {
            // todo: show on next planning
            //items.push({
            //    text: "Observ.",
            //    icon: "eye",
            //    event: PageStates.Observations
            //});
            items.push({
                title: "Kart",
                icon: "map",
                event: PilotagDetailsMenuStates.Map
            });
        }
        return items;
    }

    async function onSelect(item) {

        if (item.event === PilotagDetailsMenuStates.PilotAssignment) {
            await setPilotAssignmentSuggestions(Number(id));
        }

        const url = getPilotAssignmentUrl(pilotAssignment);
        navigate(`${url}/${item.event}`, { replace: true });
    }

    function isPilotAssignmentDirty(assignment) {
        return assignment.commands.length > 0;
    }

}


